import React from 'react';
import './Button.css';

export function Button({
    children,
    variant = 'primary', // primary, secondary, ghost, danger
    size = 'md',         // sm, md, lg
    className = '',
    loading = false,
    disabled,
    ...props
}) {
    const classes = ['btn', `btn-${variant}`, `btn-${size}`, className].filter(Boolean).join(' ');

    return (
        <button className={classes} disabled={disabled || loading} {...props}>
            {loading && <span className="btn-spinner" aria-hidden="true" />}
            <span className="btn-content">{children}</span>
        </button>
    );
}
